export default __webpack_public_path__ + "static/media/Inter-SemiBoldItalic.349f63a5.woff";